import BaseModal from "../Modals/BaseModalV2";

export default function SwitchHQWarningModal({ modalOpen, toggleModal, confirmSelectionChange }) {
    return (
        <>
            <BaseModal
                visible={modalOpen}
                toggle={toggleModal}
                headerContent={<div className="w-100 text-center">Change HQ Selection</div>}
                submitText="Confirm"
                size="md"
                onSubmit={(e) => confirmSelectionChange(e)}
                onCancel={() => toggleModal()}
            >
                <div className="text-center pb-3">
                    <div className="warning-txt fw-bold mb-2">WARNING:</div>
                    <div>By changing HQ, any unsaved changes to the current HQ will be lost.</div>
                </div>
                
            </BaseModal>

        </>

    );
}